import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import * as ShortlistActions from '@disco/state-management/actions/ShortlistActions'
import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'
import { getPlaylistSharesWithContacts } from '@disco/state-management/selectors/shares'
import { getShortlistById } from '@disco/state-management/selectors/shortlists'

import { getShortlistBaseRoute } from 'utils/routing'

import EditGroupForm from 'components/common/email-groups/edit-form'
import DocumentHeadTags from 'components/document-head-tags'

const mapStateToProps = (state, { shortlistId }) => {
  return {
    shortlist: getShortlistById(state, {
      id: shortlistId,
    }),
    shares: getPlaylistSharesWithContacts(state),
    user: state.user,
    location: getLocationBeforeTransitions(state),
  }
}

const mapDispatchToProps = { ...ShortlistActions, sendMixpanelEvent }

const connector = connect(mapStateToProps, mapDispatchToProps)
type PlaylistShare = {
  recipients: Record<string, any>[]
}
type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  params: {
    shortlistId: string
    shareId: string
  }
  navigate: NavigateFunction
}

class CreateEmailGroup extends React.Component<Props> {
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { shortlist } = nextProps

    if (!shortlist || !shortlist.playlist) {
      this.props.navigate('/')
    }
  }

  _closeGroupModal = () => {
    const { shortlistId, shareId } = this.props.params
    const baseRoute = getShortlistBaseRoute(this.props.location)
    const path = `${baseRoute}/shortlists/${shortlistId}/shared/${shareId}`
    this.props.navigate(path)
  }
  _completeGroup = (groupName: string) => {
    this.props.sendMixpanelEvent('Create email group via shortlists')
    const { shortlistId, shareId } = this.props.params
    const baseRoute = getShortlistBaseRoute(this.props.location)
    const path = `${baseRoute}/shortlists/${shortlistId}/shared/${shareId}?emailGroup=${groupName}`
    this.props.navigate(path)
  }

  render() {
    const { shareId } = this.props.params
    const { shortlist } = this.props
    if (!shortlist || !shortlist.playlist) return null
    const recipients = this.props.shares[shareId].recipients.filter(
      r => r.type !== 'business',
    )
    return (
      <div>
        <DocumentHeadTags title="Edit email group | DISCO" />
        <EditGroupForm
          noRecipientEditing
          recipients={recipients}
          onClose={this._closeGroupModal}
          onSubmit={this._completeGroup}
        />
      </div>
    )
  }
}

const ConnectedCreateEmailGroupWithNavigation = connector(CreateEmailGroup)

export default function CreateEmailGroupWithNavigation(
  props: Partial<PropsFromRedux> = {},
) {
  const navigate = useNavigate()
  const { shortlistId, shareId } =
    useParams<{ shortlistId: string; shareId: string }>()
  return (
    <ConnectedCreateEmailGroupWithNavigation
      {...props}
      navigate={navigate}
      params={{ shortlistId, shareId }}
      shortlistId={shortlistId}
    />
  )
}
